// IMPORTANT
// If you make a change to this file or add a new enum, please add/update a corresponding toString value
// in request-helpers.service.js

export enum RequestUserStatus {
    Draft = 0,
    Submitted = 1,
    Reopened = 2,
    Disapproved = 3,
    Approved = 4,
    PendingFollowUp = 5,
    FollowupExpiring=10,
    FollowUpExpired=11,
    FollowupForgiven=12,
    FollowupSubmitted = 6,
    Deleted = 7,
    Completed = 8,
    Cancelled = 9,
    FollowUpRequired=100,
    FollowUpApproved=101
}